export const Messages = {
    NoData: 'No data available',
    CustomIndexAccessRequired: 'No Access - Requires Custom Index Access',
} as const;
